import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.lookit.bottomtabs');
import { Input, Output, EventEmitter } from '@angular/core';

export interface LookitBottomTab {
    id: string;
    label: string;
    icon?: string;
    badge?: string | number;
    ariaLabel?: string;
}

@Component({
    selector: 'wiz-component-lookit-bottomtabs',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.lookit.bottomtabs/view.scss */
:host {
  display: block;
}

.lookit-bottom-tabs {
  position: relative;
  z-index: 2;
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: repeat(var(--lookit-bottom-tab-count, 5), minmax(0, 1fr));
  gap: var(--lookit-space-1);
  border-top: 1px solid var(--lookit-border-subtle);
  background: color-mix(in srgb, var(--lookit-color-surface) 96%, transparent);
  padding: var(--lookit-space-2) calc(var(--lookit-space-3) + var(--lookit-safe-area-right)) calc(var(--lookit-space-2) + var(--lookit-safe-area-bottom)) calc(var(--lookit-space-3) + var(--lookit-safe-area-left));
}

.lookit-bottom-tabs__item {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: var(--lookit-touch-tab);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: var(--lookit-radius-md);
  color: var(--lookit-color-text-muted);
  font-size: var(--lookit-font-size-2xs);
  font-weight: var(--lookit-font-weight-black);
  line-height: 1.15;
  padding: 4px 2px;
  transition: background-color 160ms ease, color 160ms ease;
}

.lookit-bottom-tabs__icon {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  color: inherit;
}

.lookit-bottom-tabs__icon svg {
  width: 21px;
  height: 21px;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.lookit-bottom-tabs__label {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lookit-bottom-tabs__badge {
  position: absolute;
  top: 5px;
  right: 50%;
  min-width: 16px;
  height: 16px;
  transform: translateX(23px);
  border-radius: var(--lookit-radius-pill);
  background: var(--lookit-color-price-drop);
  color: var(--lookit-color-on-accent);
  font-size: 10px;
  font-weight: var(--lookit-font-weight-black);
  line-height: 16px;
  text-align: center;
}

.lookit-bottom-tabs__item.is-active {
  background: var(--lookit-color-text);
  color: var(--lookit-color-surface);
}

@media (max-width: 340px) {
  .lookit-bottom-tabs {
    padding-right: calc(var(--lookit-space-2) + var(--lookit-safe-area-right));
    padding-left: calc(var(--lookit-space-2) + var(--lookit-safe-area-left));
  }
  .lookit-bottom-tabs__item {
    font-size: 10px;
  }
}`],
})
export class ComponentLookitBottomtabsComponent {
    @Input() tabs: LookitBottomTab[] = [];
    @Input() active: string = '';
    @Input() ariaLabel: string = '하단 탭';
    @Output() tabChange = new EventEmitter<string>();

    public get safeTabs(): LookitBottomTab[] {
        return Array.isArray(this.tabs) ? this.tabs : [];
    }

    public isActive(tab: LookitBottomTab): boolean {
        return tab && tab.id === this.active;
    }

    public iconName(tab: LookitBottomTab): string {
        return (tab && (tab.icon || tab.id)) || 'circle';
    }

    public select(tab: LookitBottomTab) {
        if (!tab || !tab.id) return;
        this.tabChange.emit(tab.id);
    }

    public trackByTab(_index: number, tab: LookitBottomTab): string {
        return tab?.id || '';
    }
}

export default ComponentLookitBottomtabsComponent;